import { Button } from '@/shared/ui';
import MessageIcon from '@/assets/icons/message-fill-primary.svg';
import { Variant } from './register-form-v2/verify-code';

interface IProps {
    onAction: (variant?: Variant) => void;
    variant?: 'email' | 'phone';
    initialSourceForDelivery: string;
}

const troubleVariants = {
    email: {
        content: (
            <span className="text-17 sm:text-20 font-dmSans">
                If you're having trouble verifying via email <span className="font-dmSansBold">we can text a code to your phone instead.</span>
            </span>
        ),
        action: 'Text me my code'
    },
    phone: {
        content: (
            <span className="text-17 sm:text-20 font-dmSans">
                If you’re having trouble verifying via text message <span className="font-dmSansBold">we can send a code to your email instead.</span>
            </span>
        ),
        action: 'Email me my code'
    }
};

const TroublePopup = ({ onAction, variant = 'email', prevVariantAndTarget }: IProps) => {
    const troubleVariant = troubleVariants[variant];
    console.log(prevVariantAndTarget);
    const newTargetSource = variant === 'email' ? prevVariantAndTarget.phone : prevVariantAndTarget.email;
    return (
        <div className="flex flex-col gap-[1.6875rem]" data-testid="email-having-trouble-container">
            <div className="flex flex-col items-center gap-3 md:gap-7">
                <img src={MessageIcon} alt="" />
                <div className="flex flex-col items-center gap-[0.75rem]">
                    <h4 className="font-agrandir text-25 md:text-35" data-testid="email-having-trouble-title">
                        Having Trouble?
                    </h4>
                    <div
                        data-testid="email-having-trouble-content"
                        className="w-[357px] max-w-full px-5 text-center xs:px-0"
                    >
                        {troubleVariant.content}
                    </div>

                    {newTargetSource && (
                        <p className="w-[357px] max-w-full px-5 text-center font-dmSans text-19 sm:text-22 xs:px-0">
                            {newTargetSource}
                        </p>
                    )}
                </div>
            </div>
            <div className="flex flex-col gap-2.5 md:gap-4">
                <Button testId="button-trouble-email-instead" showEndIcon onClick={() => onAction(variant === 'email' ? 'phone' : 'email')}>
                    {troubleVariant.action}
                </Button>
                <Button testId="button-trouble-have-code" variant="outlined" onClick={() => onAction()}>
                    I Already Have My Code
                </Button>
            </div>
        </div>
    );
};

export default TroublePopup;
